import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { IconMapPin, IconPhone, IconClock } from '@tabler/icons-react';
import { Card } from '../components/ui/card';
import { Skeleton } from '../components/ui/skeleton';
import { toast } from 'sonner';
import api from '../lib/api';

const AddressesPage = () => {
  const [salons, setSalons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSalons();
  }, []);

  const loadSalons = async () => {
    try {
      setLoading(true);
      const response = await api.get('/salons');
      setSalons(response.data);
    } catch (error) {
      toast.error('Ошибка загрузки адресов');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background bg-noise">
      <motion.section
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2, ease: 'easeOut' }}
        className="py-12 sm:py-16"
      >
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-['Playfair_Display'] text-4xl sm:text-5xl text-center mb-6">Наши адреса</h1>
          <p className="text-lg text-center text-[color:hsl(var(--foreground))]/70 max-w-2xl mx-auto mb-12">
            10 салонов в Самаре и Новокуйбышевске — выберите ближайший к вам
          </p>

          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1, 2, 3, 4, 5, 6].map(i => (
                <Skeleton key={i} className="h-48 rounded-[24px]" />
              ))}
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {salons.map((salon, index) => (
                <motion.div
                  key={salon.id}
                  initial={{ opacity: 0, y: 16 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.2, delay: index * 0.05, ease: 'easeOut' }}
                >
                  <Card className="bg-card border-[0.5px] border-[color:hsl(var(--hairline))] rounded-[128px] p-6 h-full" data-testid="address-card">
                    <div className="flex items-start gap-3 mb-4">
                      <IconMapPin size={20} className="text-[color:hsl(var(--brand-orange))] mt-1" stroke={1.75} />
                      <div>
                        <h3 className="font-medium text-lg mb-1">{salon.name}</h3>
                        <p className="text-sm text-[color:hsl(var(--foreground))]/70">{salon.city}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-[color:hsl(var(--foreground))]/60 mb-2">
                      <IconPhone size={16} />
                      <a href="tel:+78462028880" className="hover:text-[color:hsl(var(--brand-orange))] transition-colors">
                        8 (846) 202-88-80
                      </a>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-[color:hsl(var(--foreground))]/60">
                      <IconClock size={16} />
                      <span>Ежедневно 9:00 – 21:00</span>
                    </div>
                  </Card>
                </motion.div>
              ))}
            </div>
          )}
        </div>
      </motion.section>
    </div>
  );
};

export default AddressesPage;